import Plotly from 'plotly.js/dist/plotly-cartesian'
import React, { FC } from 'react'
import { PlotParams } from 'react-plotly.js'
import createPlotlyComponent from 'react-plotly.js/factory'

/**
 * We build this from plotly-cartesian, because plotly.js proper is _huge_,
 * and inflates the bundle size by about 10MB.
 * Plotly in Forecast should be done with:
 *
 * import Plot from 'features/plotly'.
 *
 * An explanation of the different plotly.js bundles is here:
 * https://github.com/plotly/plotly.js/blob/master/dist/README.md
 */
const PlotComponent = createPlotlyComponent(Plotly)

const RawPlot: FC<PlotParams> = (props) => {
  return <PlotComponent {...props} />
}

const Plot = React.memo(RawPlot)

export default Plot
